import { render } from "./KsaSubscriptions.vue?vue&type=template&id=11518d3c&scoped=true"
import script from "./KsaSubscriptions.vue?vue&type=script&lang=js"
export * from "./KsaSubscriptions.vue?vue&type=script&lang=js"

import "./KsaSubscriptions.vue?vue&type=style&index=0&id=11518d3c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11518d3c"]])

export default __exports__